// src/components/debug/SessionInfoPanel.tsx

import React from 'react';
import type { InitTestChatResponse } from '@dopomogai/types';
import { CodeEditorField } from '@dopomogai/ui';

interface SessionInfoPanelProps {
  config: InitTestChatResponse | null;
}

export const SessionInfoPanel: React.FC<SessionInfoPanelProps> = ({ config }) => {
  return (
    // This parent div is now ALWAYS rendered. It takes up the full height and provides padding.
    <div className="h-full overflow-y-auto p-4">
      {config ? (
        // If config exists, render the editor.
        // It will sit inside the padded, full-height, scrollable container.
        <CodeEditorField
          value={JSON.stringify(config, null, 2)}
          language="json"
          readOnly
          theme="light"
          onChange={() => {}}
          showCopyButton
        />
      ) : (
        // If config is null, render the placeholder text.
        // It will also sit inside the same full-height container.
        <div className="text-sm text-slate-500">
          No active session. Send a message to initialize.
        </div>
      )}
    </div>
  );
};